<!--  -->
<template>
  <div class="twerw_box">
    <div class="top_box">
      <div class="account_title">名称：</div>
      <div><el-input v-model="name" placeholder="请输入账户名称" /></div>
    </div>
    <div class="top_box">
      <div class="account_title">结构：</div>
      <div>
        <div v-for="item,indexr in struct" :key="indexr" class="musertw">
          <el-input
            v-model="item.strname"
            class="item_input"
          />
          <div class="musertwr">
            <el-button
              v-if="indexr === 0"
              type="success"
              @click="add"
            >+</el-button>
            <el-button
              v-if="indexr !== 0"
              type="danger"
              @click="reduce(indexr)"
            >-</el-button>
          </div>
        </div>

      </div>

    </div>
    <div>
      <el-button type="primary" @click="sumbit">确定</el-button>
    </div>
  </div>
</template>

<script>
import { bookplatformstore, bookplatformupdate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      index: 1,
      name: '',
      struct: [{
        strname: ''
      }],
      arrs: [],
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendedit(item) {
      this.id = item.id
      this.name = item.name
      this.struct = []
      item.struct.forEach(element => {
        this.struct.push({
          strname: element
        })
      })
    },
    async sumbit() {
      if (this.name === '') {
        this.$message({
          message: '请填写名称',
          type: 'error'
        })
        return
      }
      const bool = this.struct.every((item, index, array) => {
        return item.strname !== ''
      })
      if (bool === false) {
        this.$message({
          message: '请填写完整的结构',
          type: 'error'
        })
        return
      }
      this.arrs = []
      this.arrs = this.struct.map((item) => {
        return item.strname
      })
      if (this.id === null) {
        await bookplatformstore({
          name: this.name,
          struct: this.arrs
        })
        this.$message({
          message: '提交成功',
          type: 'success'
        })
        this.$emit('updataclose')
      } else {
        await bookplatformupdate({
          id: this.id,
          name: this.name,
          struct: this.arrs
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updataclose')
      }
    },
    add() {
      if (this.struct.length === 6) {
        return
      }
      this.struct.push({
        strname: ''
      })
    },
    reduce(index) {
      this.struct.splice(index, 1)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.top_box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    align-items: baseline;
}
.musertw{
    display: flex;
}
.musertwr{
    margin-left: 10px;
}
.twerw_box{
  padding-left: 50px;
}
.item_input{
  margin-bottom: 10px;
}
</style>
